/* istanbul ignore file */
import React from 'react';
import { EnumField } from 'framework/ui/field';
import { useShowContext } from 'framework/show';
import { LEAD_DISQUALIFICATION_REASON } from 'domain/sales/lead/shared/leadService';

const DisqualificationReasonField = ({
  value: inputValue = null,
  source = null,
}: {
  value?: any;
  source: Nullable<string>;
}) => {
  const { data } = useShowContext();

  const value = inputValue || (data && data.getValueBySource(source));

  return <EnumField label="Disqualification reason" value={value} options={LEAD_DISQUALIFICATION_REASON} />;
};

export default DisqualificationReasonField;
